const SELECTOR = '[data-component-confirm]';
const GET_LINK_SELECTOR = 'a:not([data-method])';
const NO_GET_LINK_SELECTOR = '[data-to][data-method]';
const FORM_BUTTON_SELECTOR = 'button[type=submit]';

async function mountConfirm(props) {
  const { default: Confirm } = await import('@bizneo/confirm/confirm.svelte');

  const confirm = new Confirm({ target: document.body, props: {...props, confirm: props['componentConfirm']} });
  $(confirm.getContainer()).trigger('dom-update', { source: 'confirm' });

  return confirm;
}

$(document).on('click', `${SELECTOR}${GET_LINK_SELECTOR}`, e => {
  e.preventDefault();
  const $el = $(e.currentTarget);
  const data = $el.data();
  const to = $el.attr('href');

  mountConfirm(data).then(confirm => {
    confirm.$on('close', () => confirm.$destroy());
    confirm.$on('confirm', () => {
      const $link = $(`<a href=${to}></a>`).hide();
      $el.after($link);
      $link[0].click();
      confirm.$destroy();
    });
  });
});

$(document).on('click', `${SELECTOR}${NO_GET_LINK_SELECTOR}`, e => {
  e.preventDefault();
  const { to, method, csrf, ...data } = $(e.target).data();

  mountConfirm(data).then(confirm => {
    confirm.$on('close', () => confirm.$destroy());
    confirm.$on('confirm', () => {
      const $form = $(`<form method="post" action=${to}></form>`);
      const metadataInput = `
        <input name="_method" value=${method} type="hidden" />
        <input name="_csrf_token" value=${csrf} type="hidden" />
      `;
      $form.hide().append(metadataInput).appendTo(document.body);
      $form.get(0).requestSubmit();
    });
  });
});

$(document).on('click', `${FORM_BUTTON_SELECTOR}${SELECTOR}`, e => {
  e.preventDefault();
  const submitButton = e.currentTarget;
  const data = $(submitButton).data();
  const form = submitButton.hasAttribute('form')
    ? document.getElementById(submitButton.getAttribute('form'))
    : submitButton.closest('form');

  if (form.reportValidity()) {
    mountConfirm(data).then(confirm => {
      confirm.$on('close', () => {
        confirm.$destroy();
      });
      confirm.$on('confirm', () => {
        form.requestSubmit(submitButton);
        confirm.$destroy();
      });
    });
  }
});
